module.exports = __webpack_public_path__ + "static/hero-image-navy-08e5aac52c5620bf84d84d0dabde5117.svg";